"use client";
import { bilhold } from "./svg/bilhold/index.js";
import { mollerbil } from "./svg/mollerbil/index.js";
import { skoda } from "./svg/skoda/index.js";
import { gumpen } from "./svg/gumpen/index.js";
import { vw, vwnytte } from "./svg/vw/index.js";
import { dahles } from "./svg/dahles/index.js";
import { autoria } from "./svg/autoria/index.js";
import { audi } from "./svg/audi/index.js";
import { cupra } from "./svg/cupra/index.js";
import { albjerk, alta, berge, fremme, kirkenes, mobile, slatlem, sulland, svebjorn } from "./svg/others/index.js";
const logos = [
  albjerk,
  alta,
  audi,
  autoria,
  berge,
  bilhold,
  cupra,
  dahles,
  fremme,
  gumpen,
  kirkenes,
  mobile,
  mollerbil,
  skoda,
  slatlem,
  sulland,
  svebjorn,
  vw,
  vwnytte
];
export {
  logos
};
